import React, { useEffect } from 'react'; // Import useEffect
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from '../../components/Header';
import DSOList from './DSOList';
import RMList from './RMList';
import AddDSO from './AddDSO';
import EditDSO from './EditDSO';
import AddRM from './AddRM';
import EditRM from './EditRM';
// Import Product Management pages
import ProductListPage from './ProductListPage';
import ProductFormPage from './ProductFormPage';
// Import Bank Management pages
import BankList from './BankList';
import BankForm from './BankForm';
// Import Commission Management pages
import GlobalCommissions from './GlobalCommissions';
import CommissionList from './CommissionList';
import CommissionForm from './CommissionForm';
    
const AdminDashboard = () => {
    
  // Set document title on mount
  useEffect(() => {
    document.title = 'Admin Dashboard';
  }, []); // Empty dependency array
    
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Navigate to="dso-list" replace />} />
        <Route path="dso-list" element={<DSOList />} />
        <Route path="dso-list/add" element={<AddDSO />} />
        <Route path="dso/:id/edit" element={<EditDSO />} />
        <Route path="rm-list" element={<RMList />} />
        <Route path="add-rm" element={<AddRM />} />
        <Route path="edit-rm/:id" element={<EditRM />} />
        {/* Add Product Routes */}
        <Route path="products" element={<ProductListPage />} />
        <Route path="products/new" element={<ProductFormPage />} />
        <Route path="products/edit/:productId" element={<ProductFormPage />} />
        {/* Add Bank Routes */}
        <Route path="banks" element={<BankList />} />
        <Route path="banks/add" element={<BankForm />} />
        <Route path="banks/edit/:bankId" element={<BankForm />} />
        
        {/* Add Commission Routes */}
        <Route path="commissions" element={<GlobalCommissions />} />
        <Route path="dso/:dsoId/commissions" element={<CommissionList />} />
        <Route path="dso/:dsoId/commissions/edit" element={<CommissionForm />} />
      </Routes>
    </>
  );
};

export default AdminDashboard;
